export default __webpack_public_path__ + "static/media/IconDesc_MagneticFieldGenerator.256.7006c62f.png";